import { Base } from '@studiometa/js-toolkit';

/**
 * Panel Class.
 */
export default class Panel extends Base {
  isOpen = false;

  static config = {
    name: 'Panel',
    refs: ['close', 'container'],
  };

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closePanel();
    }
  }

  /**
   * Close on click
   * @returns {void}
   */
  onCloseClick() {
    this.closePanel();
  }

  /**
   * Close on click
   * @returns {void}
   */
  onOverlayClick() {
    this.closePanel();
  }

  /**
   * Show Popin
   * @returns {void}
   */
  openPanel() {
    this.isOpen = true;
    document.body.classList.add('is-panel-open', 'overflow-hidden');
    this.$el.classList.remove('pointer-events-none');
    this.$el.style.clipPath = 'inset(0 0 0 0)';
  }

  /**
   * Close popin
   * @returns {void}
   */
  closePanel() {
    this.isOpen = false;
    this.$emit('close-panel');
    document.body.classList.remove('is-panel-open', 'overflow-hidden');
    this.$el.classList.add('pointer-events-none');
    this.$el.style.clipPath = 'inset(0 100% 0 0)';
  }

  /**
   * Add Date to panel and open it !
   * @param {string} content HTML Element.
   * @returns {void}
   */
  addData(content) {
    this.$refs.container.innerHTML = content;
    this.openPanel();
  }
}
